import { render, staticRenderFns } from "./TEST_page.vue?vue&type=template&id=36490a4a&scoped=true&"
import script from "./TEST_page.vue?vue&type=script&lang=js&"
export * from "./TEST_page.vue?vue&type=script&lang=js&"
import style0 from "./TEST_page.vue?vue&type=style&index=0&id=36490a4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36490a4a",
  null
  
)

export default component.exports